import { productsCategories, productsSlugs } from 'constants/products';

import basicSetPicture from '../images/gifting/gifting_essentials.jpg';
import completeSetPicture from '../images/gifting/gifting_complete.jpg';
import howItWorksDesktopTablet from '../images/gifting/dt-gifting_how_it_works.jpg';
import howItWorksMobile from '../images/gifting/m-gifting_how_it_works.jpg';
import allureLogo from '../images/logo_allure.png';
import nytLogo from '../images/logo_nyt.png';
import popSugarLogo from '../images/logo_popsugar.png';

const gift = () => ({
  hero: {
    title: 'The gift that is literally made for them',
    content: <>Take your gifting to the next level with custom hair care.</>,
  },
  philosophy: {
    title: 'The best gifts are personal',
    content: (
      <>
        This season, give them months of great hair days with a custom routine that has their name
        on it.
      </>
    ),
    cta: 'Get started',
  },
  howItWork: {
    title: 'How it works',
    imageDesktop: howItWorksDesktopTablet,
    imageMobile: howItWorksMobile,
    imageAlt: 'Assorted prose products on a table',
    content: [
      {
        title: '1. You choose the gift',
        content:
          'Select one of our two gift options. We’ll send the recipient a digital e-card on the day of your choosing with a special link where they can redeem their gift.',
      },
      {
        title: '2. They customize',
        content:
          'After receiving their digital e-card, the recipient will take the Prose consultation. Once they do, we’ll freshly bottle their custom gift set and deliver it straight to their door.',
      },
    ],
  },
  form: {
    // when we add or remove an occasion, we should make sure that we are updating the oms part in utils/gifts.js
    occasion: [
      {
        value: 'holidays',
        label: 'Holidays',
        message: 'Wishing you happy holidays. And happy hair days too!',
      },
      {
        value: 'birthday',
        label: 'Birthday',
        message:
          'Happy birthday! Wishing you all the best and only happy hair days in the year ahead.',
      },
      {
        value: 'just_because',
        label: 'Just Because',
        message:
          'You’re one-of-a-kind and you deserve to use hair care that’s been made just for you. I hope you enjoy your very own Prose.',
      },
      {
        value: 'graduation',
        label: 'Graduation',
        message:
          "You're one-of-a-kind and you deserve to use hair care that's been made just for you. Congrats on your graduation!",
      },
    ],
  },
  press: [
    {
      logo: allureLogo,
      logoAlt: 'Allure',
      width: '61px',
      review: '“I tried a customized hair-care regimen and was blown away by the results.”',
    },
    {
      logo: nytLogo,
      logoAlt: 'The New York Times',
      width: '178px',
      review:
        '“Prose is one of the biggest and most successful entrants in … customizable hair care.”',
    },
    {
      logo: popSugarLogo,
      logoAlt: 'POPSUGAR',
      width: '161px',
      review: (
        <>
          “Basically a salon
          <br /> blowout in a <br /> bottle.”
        </>
      ),
    },
  ],
  questions: [
    {
      question: 'Can I take the consultation for my recipient?',
      answer:
        'To ensure the best Prose experience, the recipient should take the consultation on their own. This way, their custom products will truly meet all of their needs and goals.',
    },
    {
      question: 'Do you have a physical gift card?',
      answer: 'Not at this time. Stay tuned!',
    },
    {
      question: 'Can I buy a gift card for a dollar amount?',
      answer:
        'Prose works best as a set of complementary products, so at the moment we only offer our curated gift bundles.',
    },
    {
      question: 'Do digital gifts expire?',
      answer: 'They don’t! Your digital gift can be redeemed at any time.',
    },
    {
      question: 'What time will my digital gift be emailed?',
      answer:
        'Your digital gift will be emailed to the recipient at 10 AM EST on the date of your choosing. If you’ve selected the day of, your digital gift will be emailed immediately upon purchase.',
    },
    {
      question: 'How can I edit or cancel a digital gift?',
      answer:
        'To edit or cancel a digital gift that hasn’t been emailed yet, please reach out to us at hello@prose.com. We can’t guarantee any changes, but we’ll do our best!',
    },
    {
      question: 'What happens if I’m not happy with my gifted products?',
      answer:
        'Your gifted products are backed by our 100% satisfaction guarantee, which covers your order within 30 days of the delivery date. You can receive adjusted formulas free of charge, or you can return your order for credit to your Prose account—both processes are free, and the digital gift purchaser won’t be notified. Just contact our team here, and we’ll provide detailed instructions.',
    },
  ],

  giftSets: [
    {
      description:
        'Our sulfate-free Shampoo and Conditioner work together for a custom wash that will target all hair needs and goals. Approximately 6-8 weeks use.',
      label: 'basic',
      name: 'The Essentials',
      picture: basicSetPicture,
      price: 56,
      productsLabels: [productsSlugs.SHAMPOO, productsSlugs.CONDITIONER],
      productsSet: [
        {
          product: productsCategories.FORMULA,
          type: productsSlugs.SHAMPOO,
          quantity: 1,
        },
        {
          product: productsCategories.FORMULA,
          type: productsSlugs.CONDITIONER,
          quantity: 1,
        },
      ],
    },
    {
      description:
        'Add our Pre-Shampoo Mask for an extra dose of active ingredients that will deeply treat your hair or scalp before you wash and condition. Approximately 6-8 weeks use.',
      label: 'complete',
      name: 'The Complete Set',
      picture: completeSetPicture,
      price: 98,
      productsLabels: [productsSlugs.SHAMPOO, productsSlugs.CONDITIONER, productsSlugs.HAIR_MASK],
      productsSet: [
        {
          product: productsCategories.FORMULA,
          type: productsSlugs.SHAMPOO,
          quantity: 1,
        },
        {
          product: productsCategories.FORMULA,
          type: productsSlugs.CONDITIONER,
          quantity: 1,
        },
        {
          product: productsCategories.FORMULA,
          type: productsSlugs.HAIR_MASK,
          quantity: 1,
        },
      ],
    },
  ],
  noRedeemableGift: 'Sorry, no redeemable gift is associated to this account',
});

export default gift;
